/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Die Abmeldung läuft …`
};

const en_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Disconnecting...`
};

const es_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrando sesión...`
};

const fr_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Déconnexion en cours...`
};

const it_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Logout in corso...`
};

const nl_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Afmelden bezig...`
};

const pt_sf_logout__loading = /** @type {(inputs: {}) => string} */ () => {
	return `Fim de sessão em curso...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sf_logout__loading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sf_logout__loading", locale)
	if (locale === "de") return de_sf_logout__loading(inputs)
	if (locale === "en") return en_sf_logout__loading(inputs)
	if (locale === "es") return es_sf_logout__loading(inputs)
	if (locale === "fr") return fr_sf_logout__loading(inputs)
	if (locale === "it") return it_sf_logout__loading(inputs)
	if (locale === "nl") return nl_sf_logout__loading(inputs)
	return pt_sf_logout__loading(inputs)
};